<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <ValidationObserver v-slot="{ failed, passed }">
          <form>
            <md-card class="p-25">
              <md-card-content>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>اسم الجهاز</label>
                      <md-input v-model="Name"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>Port</label>
                      <md-input v-model="Code"></md-input>
                    </md-field>
                  </div>

                  <!-- <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <model-list-select
                        class="input-must-rtl"
                        :list="banks"
                        v-model="BankId"
                        option-value="key"
                        option-text="value"
                        placeholder="الفرع"
                      ></model-list-select>
                      <button
                        @click="clear_BankId"
                        type="button"
                        class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                        tabindex="-1"
                      >
                        <div class="md-ripple">
                          <div class="md-button-content">
                            <i
                              class="md-icon md-icon-font md-icon-image md-theme-default"
                              ><svg
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                ></path>
                                <path d="M0 0h24v24H0z" fill="none"></path></svg
                            ></i>
                          </div>
                        </div>
                      </button>
                    </md-field>
                  </div> -->

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>IP</label>
                      <md-input v-model="Name"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                  >
                    <md-button class="md-info btn_nanosoft"
                      >تحميل بيانات الحضور لكافة الأجهزة</md-button
                    >

                    <md-button class="md-info btn_nanosoft"
                      >تحميل بيانات الحضور
                    </md-button>

                    <md-button class="md-success btn_nanosoft">اتصال</md-button>

                    <md-button @click="Save" class="md-success btn_nanosoft"
                      >حفظ</md-button
                    >

                    <md-button @click="clear" class="md-info btn_nanosoft"
                      >جديد</md-button
                    >
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- <div class="md-layout-item">
      <md-card>
        <md-card-content>
          <div class="md-layout mt-25"></div>
          <div class="md-layout flex-content-left">
            <div class="md-size-15 md-layout-item mt-25">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="الاسم">{{ item.name }}</md-table-cell>

              <md-table-cell md-label="الرمز">{{ item.code }}</md-table-cell>

              <md-table-cell md-label="المصرف">{{
                item.bankName
              }}</md-table-cell>

              <md-table-cell md-label="تصنيف فرع المصرف">{{
                item.bankClassificationName
              }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>

        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div> -->
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";

// import { SlideYDownTransition } from "vue2-transitions";
// import { extend } from "vee-validate";
// import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../env";
// extend("required", required);
// extend("numeric", numeric);
// extend("regex", regex);
// extend("confirmed", confirmed);
export default {
  async created() {
    // this.init();
  },
  components: {
    Pagination,
    ModelListSelect,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      BankId2: "",
      errorMessage: "",
      Name: "",
      Code: "",
      BankId: "",
      bankClassificationId: "",
      BankId_search: "",
      bankClassificationId_search: "",
      banks: [],
      bankClassifications: [],
      tableData: [],
      btn: "new",
      idTable: "",
      employees: [],
      updateStatus: "",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      currentSort: "Titel",
      currentSortOrder: "asc",
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null,
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    clear_BankId() {
      this.BankId = "";
    },

    clear_bankClassificationId() {
      this.bankClassificationId = "";
    },

    clear_BankId_search() {
      this.BankId_search = "";
    },

    clear_bankClassificationId_search() {
      this.bankClassificationId_search = "";
    },
    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");

        if (!this.Name) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال اسم الفرع "
          );
        }

        if (!this.Code) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال الرمز"
          );
        }

        if (!this.BankId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار مصرف"
          );
        }

        let token = atob(T);

        let schema = {
          Name: this.Name,
          Code: this.Code,
          BankId: this.BankId,
          BankClassificationId: this.bankClassificationId,
        };

        if (this.btn === "new") {
          let result = await axios.post(
            `${env.HR()}/api/bank-branches`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        } else {
          let result = await axios.put(
            `${env.HR()}/api/bank-branches/${this.idTable}`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        }
        this.btn = "new";
        // this.init();
        this.clear();
        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.message(error);
      }
    },

    async Search() {
      try {
        this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let result = await axios.get(
          `${env.HR()}/api/bank-branches/filter?BankId=${
            this.BankId_search
          }&BankClassificationId=${this.bankClassificationId_search}`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.tableData = result.data.data.results;
      } catch (error) {
        this.message(error);
      }
    },

    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(`${env.HR()}/api/bank-branches`, {
          headers: { Authorization: "Bearer " + token },
        });
        this.banks = result.data.data.banks;
        this.bankClassifications = result.data.data.bankClassifications;
        this.tableData = result.data.data.bankBranches;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },

    clear() {
      (this.Name = ""), (this.Code = ""), (this.BankId = "");
      this.bankClassificationId = "";
      this.btn = "new";
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },

    handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });

      this.btn = "Edit";
      this.idTable = item.id;
      (this.Name = item.name),
        (this.Code = item.code),
        (this.bankClassificationId = item.bankClassificationId),
        (this.BankId = item.bankId);
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/bank-branches/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            // this.init();
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            let result =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ];
            return this.notifyVue("top", "center", "danger", result[0]);
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3,
    });
  },
};
</script>


<style scoped>
.w-100 {
  width: 100%;
}
</style>
